import splitbee from "@splitbee/web"
import React, { useContext, useEffect, useState } from "react"
import { Helmet } from "react-helmet"
import GlobalStateContext from "./globalState"
import Trackers from "./trackers"
import { Analytics } from '@vercel/analytics/react';

interface MetaDataProps {
  title: string
  description: string
  image: string
  url: string
  href: string
  keywords: string
  isNoIndex: boolean
}

const MetaData = (props:MetaDataProps) => {
  const {title, description, image, url, keywords, isNoIndex, href} = props
  const { isCookieEnabled } = useContext(GlobalStateContext);
  const [isCookieEnabledState, setIsCookieEnabled] = useState(false);

  useEffect(() => {
    setIsCookieEnabled(isCookieEnabled);
  }, [isCookieEnabled]);

  const metaTags = [
    <meta key="title" name="title" content={String(title)} />,
    <meta key="description" name="description" content={String(description)} />,
    <meta key="keywords" name="keywords" content={String(keywords)} />,
    <meta key="image" property="image" content={String(image)} />,
    <meta key="twitter:image" property="twitter:image" content={String(image)} />,
    <meta key="og:image" property="og:image" content={String(image)} />,
    <meta key="google-site-verification" name="google-site-verification" content="xM27XvmGlYrY6SPucylR38xWiR6Q_xowvetUexAaiMs" />,
    <meta key="twitter:card" name="twitter:card" content="summary_large_image" />,
    <meta key="twitter:title" name="twitter:title" content={String(title)} />,
    <meta key="twitter:url" name="twitter:url" content={String(url)} />,
    <meta key="twitter:description" name="twitter:description" content={String(description)} />,
    <meta key="twitter:creator" name="twitter:creator" content="@wbetiago" />,
    <meta key="google" name="google" content="notranslate" />,
    <meta key="notranslate" httpEquiv="Content-Language" content="en" />,
  ];

  const getNoIndexElement = () => {
    if (isNoIndex) {
      return <meta name="robots" content="noindex" />;
    }
    return null;
  };

  const getCannonicalElement = () => {
    if (href) {
      return <link rel="canonical" href={href} />;
    }
    return null;
  };

  return (
    <>
      <Helmet htmlAttributes={{ translate: "no" }}>
        <title>{String(title)}</title>
        {metaTags}
        {getCannonicalElement()}
        {getNoIndexElement()}
        <script 
          type="application/ld+json" 
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "SoftwareApplication",
              "name": "PodSqueeze",
              "operatingSystem": "MULTI",
              "applicationCategory": "Utility", 
              "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.8",
                "ratingCount": "523"
              },
              "offers": {
                "@type": "Offer",
                "price": "0.00",
                "priceCurrency": "USD"
              }
            })
          }} 
        />
      </Helmet>
      {metaTags}
      <Trackers isCookieEnabled={isCookieEnabledState}/>
      <Analytics />
    </>
  )
}

export default MetaData;